import eventBus from '@/helpers/event-bus'

export default function (_this) {
  return {
    /**
     * Add FullCalendar component
     * @param {string} calendarId - calendar id to bind data grid to it
     * @param {string} gridTitle - title of the grid that will be created
     * @param {string} gridStorageType - type of storage
     * @param {string} gridSource - source path to grid data
     * @param {string} gridOnTab - tab id where data grid component will be created
     * @param {string} currentTab - tab id where full calendar component will be created
     * @param {function} cb - callback function
     */
    async create (data, cb) {
      await this.createStorage(data)

      const {
        calendarId,
        gridSource: dataGrid,
        currentTab: tab
      } = data

      await new Promise((resolve) => {
        _this.getRef('widgetsData/fullCalendar')
          .child(calendarId)
          .child('gridId')
          .set(dataGrid, () => (resolve()))
      })

      const widget = {
        ...data.gsOptions,
        template: `<FullCalendar calendarId="${calendarId}" />`,
        tab,
        subtab: data.subtab || null
      }

      const widgetKey = await new Promise((resolve) => {
        _this.widgets.create(widget, (key) => {
          resolve(key)
          cb(key)
        })
      })

      _this.getRef(`widgets/${widgetKey}/dependency`)
        .set(`fullCalendar/${calendarId}`)
    },
    /**
     * Get ids of existing calendars
     * @param {function} cb - callback function
     */
    getIds (cb) {
      _this.getRef('widgetsData/fullCalendar').on('value', (snapshot) => {
        const calendars = snapshot.val()

        if (calendars) cb(Object.keys(calendars))
        else cb(null)
      })
    },
    /**
     * Get calendar events related to current user
     * @param {string} calendarId - calendar id
     * @param {function} cb - callback function
     */
    async getEvents (calendarId, uid, cb) {
      _this.getRef('widgetsData/fullCalendar')
        .child(calendarId)
        .child('events')
        .child(uid)
        .on('value', (snapshot) => {
          cb(snapshot.val())
        })
    },
    /**
     * Set events for certain user
     * @param {string} calendarId - calendar id
     * @param {string} uid - user id
     * @param {Array} events - events
     */
    setEvents (calendarId, uid, events) {
      _this.getRef('widgetsData/fullCalendar')
        .child(calendarId)
        .child('events')
        .child(uid)
        .set(events)
    },
    getOptions (calendarId) {
      return new Promise((resolve) => {
        _this.getRef('widgetsData/fullCalendar')
          .child(calendarId)
          .once('value', (snapshot) => {
            resolve(snapshot.val())
          })
      })
    },
    async createStorage (data) {
      const gridData = {
        title: data.gridTitle,
        storageType: data.gridStorageType,
        source: data.gridSource,
        tab: data.gridOnTab,
        subtab: data.subtab || null,
        calendarId: data.calendarId
      }

      await _this.dataGrid.widget.createNew(gridData)

      const columns = [
        {
          addMethod: 'addUserColumn',
          data: {
            displayName: 'User',
            propertyName: 'user',
            type: 'user',
            gridId: data.gridSource
          }
        },
        {
          addMethod: 'addDateColumn',
          data: {
            displayName: 'Start time',
            propertyName: 'start',
            type: 'date',
            gridId: data.gridSource
          }
        },
        {
          addMethod: 'addDateColumn',
          data: {
            displayName: 'End time',
            propertyName: 'end',
            type: 'date',
            gridId: data.gridSource
          }
        },
        {
          addMethod: 'addTextColumn',
          data: {
            displayName: 'Task name',
            propertyName: 'title',
            type: 'string',
            gridId: data.gridSource
          }
        }
      ]

      for (let column of columns) {
        const {
          propertyName,
          displayName,
          gridId,
          type
        } = column.data

        let controlType

        switch (type) {
          case 'string': controlType = 'text'
            break
          case 'multiline_text': controlType = 'multiline_text'
            break
/*          case 'text_editor': controlType = 'text_editor'
            break*/
          case 'date': controlType = 'datepicker'
            break
          case 'lookup': controlType = 'lookup'
            break
          case 'multi_lookup': controlType = 'multi_lookup'
            break
          case 'files': controlType = 'files'
            break
          case 'custom': controlType = 'custom'
            break
          case 'checkbox': controlType = 'checkbox'
            break
          case 'user': controlType = 'user'
            break
        }

        await new Promise((resolve) => {
          _this.dataGrid.data[column.addMethod](column.data, (err) => {
            if (err) console.error(err)
            resolve()
          })
        })

        eventBus.$emit(
          `addControl${gridId}`,
          controlType,
          propertyName,
          displayName
        )
      }
    }
  }
}
